import { render, staticRenderFns } from "./InvoiceHeaderList.vue?vue&type=template&id=505e28de&"
import script from "./InvoiceHeaderList.vue?vue&type=script&lang=js&"
export * from "./InvoiceHeaderList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceHeaderList.vue?vue&type=style&index=0&id=505e28de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports